import { DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const PlaybookFastlanePerformanceCSVExportQuery: CubeQuery = {
  name: 'PlaybookFastlanePerformanceCSVExportQuery',
  queryName: 'PlaybookFastlanePerformanceCSVExportQuery',
  query: {
    measures: [
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_FORMFILLS,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_SENT,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_END_USER_ENGAGED,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_CONVERSATION_HELD,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_MEETING_BOOKED,
    ],
  },
}
